export const MEASUREMENT_ESTIMATES = {
  // Used as a flat-rate price table lookup sentinel when measurement is skipped.
  FLAT_RATE_LOOKUP_ESTIMATE_SQFT: 1000,
};

